import PasswordVaultIcon from "../../assets/images/sidebar/password_vault.svg";

const passwordVaultModule = {
  name: "Password Vault",
  key: "password_vault",
  imgSrc: PasswordVaultIcon,
  submodules: [
    {
      name: "Vault Dashboard",
      key: "vault_dashboard",
      defaultExpanded: false,
      features: [
        {
          key: "can_view_vault_dashboard",
          name: "Can View Vault Dashboard",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_clients_list",
              name: "View Clients List",
              defaultEnabled: true,
              description: "Access client password vault overview"
            },
            {
              key: "view_client_password_vault",
              name: "View Client's Password Vault",
              defaultEnabled: false,
              description: "View stored credentials"
            },
          ]
        }
      ]
    }
  ]
};

export default passwordVaultModule;
